__webpack_require__.p = "https://www.angelai.com/masterminds/";